mutation checkSenderVerification($senderId: ID!) {
  sender: checkSenderVerification(senderId: $senderId) {
    id
    isVerified
    fromEmail
    isAcknowledged
    name
  }
}
